/**
 * Styled Components - Created by Alfredo on 02/05/25.
 */
import styled from 'styled-components'
import Input from 'antd/lib/input'
import Button from 'antd/lib/button'
import DatePicker from 'antd/lib/date-picker'
import Select from 'antd/lib/select'
import { GRAY_LIGHT, GRAY_SHADOW, WHITE_SMOKE, BLUE, RED } from '../../theme/colors'

interface CellProps {
  color?: string
  bold?: boolean
  secondary?: boolean
  textAlign?: string
  blinking?: boolean
  link?: boolean
  small?: boolean
}

const Search = Input.Search

export const Container = styled.div`
  padding-bottom: 36px;
  width: 100%;
  padding-right: 14px;
  margin-top: -16px;
`

export const BackContainer = styled.div`
  align-items: center;
  margin-bottom: 24px;
  width: 76px;
  font-size: 14px;
  color: ${RED};
  @media (max-width: 768px) {
    display: flex;
  }
  &:hover {
    cursor: pointer;
  }
`

export const ScreenTitleFilters = styled.div`
  position: absolute;
  top: -30px;
  left: -1px;
  font-size: 14px;
  background: white;
  border: 1px solid #DCDCDC;
  padding: 1px 14px;
  border-bottom: none;
  z-index: 2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-left-radius: 0px;
  color: #5f6062;
  font-family: Avenir;
  font-weight: 600;
  padding-top: 8px;
  padding-bottom: 2px;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const SearchInput = styled(Search)`
  margin-bottom: 20px;
  margin-top: 0px;
  border-radius: 3px;
  margin-left: 4px;
  width: 400px;
  & input {
    border-radius: 3px;
    padding: 7px;
    height: 40px;
  }
  @media (max-width: 698px) {
    width: 98%;
  }
`

export const Filters = styled.div`
  border: 1px solid ${GRAY_LIGHT};
  margin-left: 4px;
  padding: 12px;
  margin-bottom: 14px;
  display: flex;
  width: 100%;
  max-width: 800px;
  border-radius: 5px;
  position: relative;
  border-top-left-radius: 0px;
  padding-top: 8px;
  box-shadow: 2px 2px 7px ${GRAY_SHADOW};
  flex-direction: column;
  @media (max-width: 698px) {
    flex-wrap: wrap
    margin-bottom: 20px;
    display: none;
  }
`

export const StyledSelect = styled(Select)`
  height: 40px;
  & .ant-select-selection {
    border-radius: 3px;
    height: 40px;
  }
  .ant-select-selection__rendered {
    line-height: 38px;
  }
  @media (max-width: 698px) {
    margin-bottom: 18px;
  }
`

export const Options = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 698px) {
    flex-wrap: wrap;
  }
`

export const StyledDatePicker = styled(DatePicker)`
  height: 40px;
  input {
    border-radius: 3px;
    height: 40px;
  }
  @media (max-width: 698px) {
    margin-bottom: 18px;
  }
`
interface ButtonWrapperProps {
  disabled?: boolean
}

export const StyledButton = styled(Button)`
  height: 40px;
  border-radius: 5px;
  width: 100%;
`

export const ButtonWrapper = styled.div`
  max-width: 128px;
  width: 100%;
  align-self: flex-end;
  .ant-btn-primary {
    background-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
    border-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
  }
  .ant-btn-primary:hover {
    background-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
    border-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
  }
  @media (max-width: 768px) {
    margin-bottom: 18px;
  }
  @media (max-width: 698px) {
    width: 95%;
    max-width: 100%;
    .ant-btn {
      width: 100%;
    }
  }
`

export const InputDiv = styled.div`
  display: flex;
  flex-flow: column;
  width: 20%;
  margin-right: 15px;
  @media (max-width: 698px) {
    width: 45%;
  }
`

export const Label = styled.div`
  margin-bottom: 8px;
  font-size: 12px;
  color: #b1b1b1;
`

export const BottomDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 16px;
  @media (max-width: 698px) {
    flex-wrap: wrap
    margin-bottom: 20px;
    display: none;
  }
`

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin-bottom 24px;
  position: relative;
`

export const ItemOrder = styled.tr`
  &:hover {
    cursor: pointer;
    background-color: #f6f6f6;
  }
`

export const Cell = styled.td`
  border-bottom: 1px solid #d7d7d7;
  text-align: left;
  padding: 8px 0;
  position: relative;
  font-weight: ${({ bold }: CellProps) => bold ? 'bold' : 'normal'};
  color: ${({ color }: CellProps) => (color ? color : '#5f6062')};
  font-size: ${({ small }: CellProps) => small ? '11px' : '12.5px'};
  letter-spacing: 0.1px;
  line-height: 35px;
  width: ${({ secondary }: CellProps) => secondary ? '78px' : 'auto'};
  transition: all .25s;
  text-align: ${({ textAlign }: CellProps) =>
    textAlign ? textAlign : 'start'};
  @media (min-width: 331px) and (max-width: 768px) {
    letter-spacing: 0.09px;
    font-size: 12px;
  }

  @media (max-width: 330px) and (max-width: 768px) {
    letter-spacing: 0.09px;
    font-size: 11px;
  }
  &:hover {
    animation: none;
    opacity: ${({ link }: CellProps) => link ? '0.5' : '1'};
    text-decoration: ${({ link }: CellProps) => link ? 'underline' : 'unset'};
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: absolute;
  height: 100%;
  background: #ffffffa3;
  z-index: 2;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizeRecs/styledComponents.tsx